export default "__VITE_ASSET__D5fvUH_K__"